export default function AscButtons({ buttons, dataSet, send, sendPayload, setButtons, mainSizing, isExpanded, customMaxWidth }) {
    const { buttons_bg_color, buttons_text_color } = dataSet

    const firstButton = buttons[0]

    const handleButtonClick = button => {
        if (button?.custom?.downloadUrl) {
            window.open(button?.custom?.downloadUrl, '_blank')
        }
        sendPayload(button)
    }

    const buttonCustomMaxWidth = isExpanded ? '550px' : customMaxWidth

    return (
        <>
            {firstButton?.custom?.customElement ? (
                <firstButton.custom.customElement
                    send={send}
                    buttonData={firstButton}
                    setButtons={setButtons}
                />
            ) : (
                <div
                    className='flexC buttonList'
                    style={{
                        maxWidth: `calc(${buttonCustomMaxWidth} - 150px)`,
                        display: 'grid',
                        justifyContent: 'start',
                    }}
                >
                    {buttons.map((button, index) => (
                        <button
                            key={index}
                            className='responseButton'
                            onClick={() => handleButtonClick(button)}
                            style={{
                                backgroundColor: button?.custom?.color ? button?.custom?.color : buttons_bg_color,
                                color: buttons_text_color,
                                justifyContent: button.subtext || button.img ? 'space-between' : 'center',
                                width: '100%',
                                minWidth: '100px',
                            }}
                        >
                            <div
                                className='ascbuttonTextContainer'
                                style={{ flexGrow: button.subtext ? '1' : 'unset' }}
                            >
                                <div
                                    className='ascButtonText'
                                    style={{
                                        textAlign: button.subtext && !button.img ? 'center' : 'left',
                                    }}
                                >
                                    {button.text}
                                </div>
                                {button?.subtext && (
                                    <div
                                        className='ascButtonSubtext'
                                        style={{
                                            textAlign: button.subtext && !button.img ? 'center' : 'left',
                                        }}
                                    >
                                        {button?.subtext}
                                    </div>
                                )}
                            </div>
                            {button.img && (
                                <img
                                    alt='button_icon'
                                    src={button.img}
                                    className='buttonImage'
                                    style={{
                                        height: '25px',
                                        width: '25px',
                                    }}
                                />
                            )}
                        </button>
                    ))}
                </div>
            )}
        </>
    )
}
